module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/05f519c617524c6958c6f2c97b68a9b2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Epic/Epic3.svg
// module id = Z6mg
// module chunks = 1